import React from 'react';
import PropTypes from 'prop-types';

import { CartItem } from '../../../helpers/proptypes';
import EditionPreviews from '../campaigns/EditionPreviews';

CartWizardStepMediaNavigator.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  edition: PropTypes.object,
};

CartWizardStepMediaNavigator.defaultProps = {
  edition: {},
};

function CartWizardStepMediaNavigator({ edition }) {
  return (
    <div className="wizard-step-media-navigator">
      <div className="details-content">
        <EditionPreviews editionPreviews={edition.previews} />
      </div>
    </div>
  );
}

export default CartWizardStepMediaNavigator;
